import { FC } from 'react';
import { Heading, Icon, Text, VStack } from '@chakra-ui/react';
import { CheckMark } from '../../assets';
import { CopyLink } from '../copy-link';
import { SocialShare } from '../social-share';

interface ConfirmationStepProps {
  customUrl: string;
}

export const ConfirmationStep: FC<ConfirmationStepProps> = (props) => {
  const { customUrl } = props;
  const confirmationMessage = `Your custom fundraising page URL has been saved. Now, share your fundraising message with the world`;

  return (
    <VStack spacing={6} alignItems="flex-start">
      <VStack color="brand.primary.swatch1" textAlign="center" w="full">
        <Icon as={CheckMark} boxSize="48px" />
        <Heading fontSize={24}>Custom URL saved</Heading>
      </VStack>

      <Text>{confirmationMessage}</Text>
      <SocialShare url={customUrl} trackingLabel="customUrlConfirm" />

      <VStack align="stretch" spacing={4} w="full">
        <CopyLink
          copyLinkText="Copy Link"
          trackingLabel="customUrlConfirm"
          url={customUrl}
        />
      </VStack>
    </VStack>
  );
};
